import { A } from '@adornis/base/env-info.js';
import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import { downloadLink } from '@adornis/file-utils/client/helper-methods.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { firstValueFrom, timer } from 'rxjs';
import { Workshop } from '../../entities/workshop.js';
import type { BHTranslationDictionary } from '../../translations/translation.js';
import type { WorkshopParticipationExportPlugin } from '../plugin-types.js';

export const defaultWorkshopParticipationExportPlugin: WorkshopParticipationExportPlugin = {
  id: 'workshop-participation-export::default',
  type: 'workshop-participation-export',
  render: (
    host: ChemistryLitElement,
    translation: TranslationController<BHTranslationDictionary>,
    institutionID: string,
    workshop,
  ) => html`
    <x-flex space="md">
      <x-h3> Import / Export </x-h3>
      <x-flex horizontal space="md">
        <x-button
          mode="outline"
          icon="download"
          @click=${async () => {
            let exportFileName = workshop.name;
            const startDate = workshop.appointments.at(0)?.start?.toFormat('yyyy-MM-dd');
            const endDate = workshop.appointments.at(-1)?.start?.toFormat('yyyy-MM-dd');
            if (startDate) exportFileName += ` ${startDate}`;
            if (endDate && startDate !== endDate) exportFileName += ` - ${endDate}`;
            exportFileName += '.csv';

            try {
              await XNativeDialog.waitFor(
                Promise.all([
                  Workshop.exportWorkshopParticipantsCSV(workshop._id)().then(fileName =>
                    downloadLink(A.absoluteUrl(`/__export/download/${fileName}`), exportFileName),
                  ),
                  firstValueFrom(timer(500)),
                ]),
              );
            } catch (e) {
              if ((e as any).message === 'file is empty') {
                await XNativeDialog.alert(translation.translate('imp_exp', 'no_data_found'));
              } else {
                await XNativeDialog.alert(translation.translate('workshop', 'export_err'));
              }
            }
          }}
        >
          ${translation.translate('imp_exp', 'exp_participants')}
        </x-button>
      </x-flex>
    </x-flex>
  `,
};
